module.exports = __webpack_public_path__ + "media/images/icons/material/tag-d6a8f9c2805f78b10d523b4e376b7107.svg";